<template>
  <div class="grouping">
    <el-dialog
      title="分组权限"
      width="500px"
      append-to-body
      :visible.sync="visible"
      @close="clearData"
      @open="openData"
      :show="show"
      :close-on-click-modal="false"
    >
      <div class="grouping_div">
        <el-checkbox v-model="checked.ShowCost" @change="change( 'ShowCost' )">允许查看成本</el-checkbox>
        <el-checkbox v-model="checked.OtherDraft" @change="change( 'OtherDraft' )">允许查看他人草稿</el-checkbox>
        <el-checkbox v-model="checked.OtherBill" @change="change( 'OtherBill' )">允许查看他人过账单据</el-checkbox>
        <el-checkbox v-model="checked.ExecuteDraft" @change="change( 'ExecuteDraft' )">允许过账他人草稿</el-checkbox>
        <el-checkbox v-model="checked.DelOtherDraft" @change="change( 'DelOtherDraft' )">允许删除他人草稿</el-checkbox>
      </div>
      <div class="content_footer_box">
        <el-button type="success" size="mini" style="display:block" @click="saveInfor">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tool from "@/utils/tool.js";
export default {
  data() {
    return {
      visible: this.show, // 是否显示选择弹框
      checked: {
        ShowCost: false,
        OtherDraft: false,
        ExecuteDraft: false,
        DelOtherDraft: false,
        OtherBill: false
      }
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show() {
      this.visible = this.show;
    }
  },
  methods: {
    // 保存按钮进行统一修改
    saveInfor(data) {
      this.$confirm("是否确定修改分组权限，确定将关闭所有页面？", "确认提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 请求权限改变接口
          let jparams = {
            user_id: tool.getLocal("userid"), //用户id
            session_id: tool.getLocal("sessionid"), //用户凭证
            GroupId: this.checked.GroupId,
            ShowCost: this.checked.ShowCost,
            OtherDraft: this.checked.OtherDraft,
            ExecuteDraft: this.checked.ExecuteDraft,
            DelOtherDraft: this.checked.DelOtherDraft,
            OtherBill: this.checked.OtherBill
          };
          this.request
            .post("/index/Privileges/update_group_other_priv", {
              jparams: JSON.stringify(jparams)
            })
            .then(res => {
              this.$tab.closeAll();
              tool.popMessage(this, res.description, "success");
            });
        })
        .catch(() => {
          tool.popMessage(this, "已取消刷新", "info");
        });
    },
    change(data) {},
    openData() {
      let jparams = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        GroupId: this.$attrs.permissions.GroupId
      };
      this.request
        .post("/index/Privileges/search_group", {
          jparams: JSON.stringify(jparams)
        })
        .then(res => {
          this.checked = res.data[0];
        });
    },
    // 退出清除数据
    clearData() {
      // 退出前是数据初始化
      this.$emit("update:show", false);
      this.checked = {
        ShowCost: false,
        OtherDraft: false,
        ExecuteDraft: false,
        DelOtherDraft: false,
        OtherBill: false
      };
    }
  }
};
</script>
<style lang="less" scoped>
.content_footer_box {
  display: flex;
  justify-content: flex-end;
}
.grouping_div {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  .el-checkbox {
    margin-bottom: 15px;
  }
  .content_footer_box {
    display: -webkit-box !important;
    display: box !important;
    position: relative;
    -webkit-box-align: center;
    box-align: center;
    -webkit-box-pack: end;
    box-pack: end;
    margin: 10px auto 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/grouping/grouping.vue